import React from 'react';

function SkeletonBlock({ width = '100%', height = '16px', borderRadius = '8px', style = {} }) {
  return <div className="skeleton" style={{ width, height, borderRadius, ...style }} />;
}

function StatCardSkeleton() {
  return (
    <div className="rounded-3xl bg-panel ring-1 ring-line p-5 flex flex-col gap-2.5">
      <SkeletonBlock width="55%" height="11px" /><SkeletonBlock width="40%" height="28px" /><SkeletonBlock width="50%" height="11px" />
    </div>
  );
}

function TableRowsSkeleton({ rows = 5, cols = 4 }) {
  return (
    <div className="flex flex-col">
      {Array.from({ length: rows }).map((_, i) => (
        <div key={i} className="grid gap-4 px-4 py-3.5 border-b border-line" style={{ gridTemplateColumns: `repeat(${cols}, 1fr)` }}>
          {Array.from({ length: cols }).map((_, j) => <SkeletonBlock key={j} width={j === 0 ? '70%' : j === cols - 1 ? '40%' : '80%'} height="14px" />)}
        </div>
      ))}
    </div>
  );
}

function CardSkeleton({ height = '120px', className = '' }) {
  return (
    <div className={`rounded-3xl bg-panel ring-1 ring-line p-5 flex flex-col gap-2.5 ${className}`} style={{ height }}>
      <SkeletonBlock width="40%" height="12px" /><SkeletonBlock width="70%" height="20px" /><SkeletonBlock width="55%" height="12px" />
    </div>
  );
}

const Skeleton = { Block: SkeletonBlock, StatCard: StatCardSkeleton, TableRows: TableRowsSkeleton, Card: CardSkeleton };
export default Skeleton;
